export default {
  "title": {
    "ranking": "Classificação do piloto",
    "mainIndicators": "Principais indicadores para cálculo do grau comportamental do período",
    "dailyBehaviorGrade": "Nota comportamental diária"
  },
  "help": {
    "mainIndicators": "Cada um desses indicadores é calculado com base no número de eventos registrados por viagem, na duração da viagem e nos quilômetros percorridos no período de datas selecionado."
  },
  "labels": {
    "behaviorGrade": "Nota comportamental"
  },
  "graphTooltip": {
    "behaviorGrade": "Dia da nota"
  },
  "table": {
    "ranking": "Nº de classificação",
    "driverName": "Nome do motorista",
    "behaviorGrade": "Nota comportamental"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/behavior/detailBehavior.js